// @packages
import { makeStyles } from '@rneui/themed';

export default makeStyles((theme) => ({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: theme.colors.background
  },
  title: {
    marginTop: 30,
    width: '90%',
    textAlign: 'left',
    color: '#63686c',
    fontWeight: 'bold'
  },
  siteName: {
    marginTop: 20,
    marginBottom: 30,
    fontWeight: 'bold',
    fontSize: 25,
    color: theme.colors.primary
  },
  warningIcon: {
    marginLeft: 5
  }
}));
